export default "__VITE_ASSET__a9552b0a__"